export const consultationCondition: any = {
  withWhom: "Who are you going with?",
  hopeForHotel: "Hope for hotel",
  hopeForFlight: "Hope for flight",
};
